module.exports = __webpack_public_path__ + "static/media/icon_map_pin.e2e317e0.svg";